// **** import modules ****
import $ from "jquery";


// **** process ****
export default {
	init() {
		this.$elements = $(".post-thumbnail");
		
		this.$elements.each((i, elm) => {
			const $frame = $(elm);
			const $img = $frame.children("img");
			if(!$img.length) {
				return true;
			}
			
			$img.on("load", e => {
				const original = {
					h: $img.height(),
					w: $img.width()
				};
				
				const imgRatio = original.h / original.w;
				
				const attr = {
					"data-original-height": original.h,
					"data-original-width": original.w,
					"data-ratio": Math.round(imgRatio * 100) / 100
				};
				
				if(imgRatio === 1) {
					attr["data-original-shape"] = "square";
				} else {
					attr["data-original-shape"] = (imgRatio > 1) ? "vertically" : "horizontally";
				}
				
				const frameRatio = parseFloat( $frame.innerHeight() ) / parseFloat( $frame.innerWidth() );
				attr["data-fit-to"] = (imgRatio < frameRatio) ? "h" : "w";
				
				$img.attr(attr).addClass("is-loaded");
			});
			
			!!$img.height() && $img.trigger("load", [true]);
		});
	}
};
